"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySystemPasswordType = void 0;
var KeySystemPasswordType;
(function (KeySystemPasswordType) {
    KeySystemPasswordType["UserInputted"] = "user_inputted";
    KeySystemPasswordType["Randomized"] = "randomized";
})(KeySystemPasswordType || (exports.KeySystemPasswordType = KeySystemPasswordType = {}));
